import type { FC } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

interface TablePaginationProps {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
    onPageChange: (page: number) => void;
}

const TablePagination: FC<TablePaginationProps> = ({
                                                       currentPage, totalPages, totalItems, itemsPerPage, onPageChange,
                                                   }) => {
    if (totalItems === 0) return null;

    const startIndex = (currentPage - 1) * itemsPerPage;

    return (
        <div className="flex items-center justify-between border-t border-stone-200 bg-stone-50/30 px-4 py-3">
            <p className="text-sm text-stone-600">
                Showing <span className="font-medium">{startIndex + 1}</span> to{' '}
                <span className="font-medium">{Math.min(startIndex + itemsPerPage, totalItems)}</span>{' '}
                of <span className="font-medium">{totalItems}</span> results
            </p>
            <nav className="flex items-center gap-1">
                <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}
                        className="rounded-lg border border-stone-300 bg-white p-2 shadow-sm hover:bg-stone-50 disabled:opacity-40">
                    <ChevronLeftIcon className="h-4 w-4" />
                </button>
                <span className="px-2 text-xs font-medium text-stone-600">
                    Page {currentPage} of {totalPages}
                </span>
                <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}
                        className="rounded-lg border border-stone-300 bg-white p-2 shadow-sm hover:bg-stone-50 disabled:opacity-40">
                    <ChevronRightIcon className="h-4 w-4" />
                </button>
            </nav>
        </div>
    );
};

export default TablePagination;